import { atom, useRecoilState } from 'recoil';

const contactsSelectedState = atom({
  key: 'ContactsSelected',
  default: []
})

const lastContactCheckedState = atom({
  key: 'LastContactChecked',
  default: null
})

const filtersState = atom({
  key: 'ContactsFilters',
  default: {
    verbatim: '',
    created_at_start: null,
    created_at_end: null,
    status: [],
    roles: [],
    internal: false,
    sync: []
  },
});

const sortState = atom({
  key: 'ContactsSort',
  default: {
    by: 'created_at',
    direction: 'desc',
  },
});

const rolesModificationsState = atom({
  key: 'ContactsRolesModifications',
  default: {} 
});

const useFilters = () => {
  return useRecoilState(filtersState);
};

export const useContactsSelected = () => {
  return useRecoilState(contactsSelectedState);
};

export const useLastContactCheckedState = () => {
  return useRecoilState(lastContactCheckedState)
}

export const useIdsSelected = () => {
  const [contactsSelected, setContactsSelected] = useContactsSelected();
  
  return [
    contactsSelected.map(contact => contact.sf_id),
    (newSelection) => {
      if (Array.isArray(newSelection) && newSelection.length === 0) {
        setContactsSelected([]);
      }
    }
  ];
};

export const useSort = () => {
  const [{ direction, by }, setSort] = useRecoilState(sortState)
  return [
    { direction, by },
    (sort) => {
      if (by === sort) {
        const newDirection = direction === 'asc' ? 'desc' : 'asc'
        setSort({ by: sort, direction: newDirection })
      } else {
        setSort({ by: sort, direction: 'asc' })
      }
    },
  ]
}

export const useRolesModifications = () => {
  return useRecoilState(rolesModificationsState);
};

export default useFilters;
